import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

const CampaignOutlined = forwardRef<SVGSVGElement, BusinessIconImageProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <path d="M4.19556 9.22013L16.3044 5.18384V16.7161L4.19556 12.6798V9.22013Z" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.3044 8.21613C18.8044 8.71613 19.8044 10.2161 19.8044 11.7161C19.8044 13.2161 18.8044 14.7161 16.3044 15.2161" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.80444 13.7161V17.2161C6.80444 17.6405 6.97301 18.0474 7.27307 18.3475C7.57313 18.6476 7.9801 18.8161 8.40444 18.8161C8.82879 18.8161 9.23576 18.6476 9.53581 18.3475C9.83587 18.0474 10.0044 17.6405 10.0044 17.2161V14.9161" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
);

CampaignOutlined.displayName = 'CampaignOutlined';

export default CampaignOutlined;
